import { defineMessages } from "react-intl";

import { useFormatMessage } from "../../../Intl/Context";
import ContributionsDatavizSortingButton from "./ContributionsDatavizSortingButton";

export const CONTRIBUTIONS_SORT_ORDER_MOST_RECENT = {
  field: "publishedAt",
  direction: "desc"
};
export const CONTRIBUTIONS_SORT_ORDER_MOST_ANIMATED = {
  field: "reactionsCount",
  direction: "desc"
};
// Random ordering requires a seed to be provided to the server, to allow the pagination
// to work, without re-randomizing the contributions on each pagination call, which would
// make the same contributions to appear multiple times, and certain contributions to
// never appear in most cases.
export const CONTRIBUTIONS_SORT_ORDER_RANDOM = {
  field: "random",
  direction: "asc",
  requiresSeed: true
};

export const CONTRIBUTIONS_SORT_ORDERS = {
  mostRecent: CONTRIBUTIONS_SORT_ORDER_MOST_RECENT,
  mostAnimated: CONTRIBUTIONS_SORT_ORDER_MOST_ANIMATED,
  random: CONTRIBUTIONS_SORT_ORDER_RANDOM
};

const ContributionsDatavizSorting = () => {
  const t = useFormatMessage();
  const titleLabel = t(intlMessages.title);

  const sortOrderKeys = Object.keys(CONTRIBUTIONS_SORT_ORDERS);

  return (
    <div className="box padding-sm margin-bottom-xs">
      <b className="d-block margin-bottom-xs">{titleLabel}</b>
      <div className="btn-group btn-group-sm d-flex rounded">
        {sortOrderKeys.map(sortOrderKey => (
          <ContributionsDatavizSortingButton
            key={sortOrderKey}
            sortOrderKey={sortOrderKey}
          />
        ))}
      </div>
    </div>
  );
};

export default ContributionsDatavizSorting;

const intlMessages = defineMessages({
  title: {
    id: "contributions.dataviz.sorting.title",
    defaultMessage: "Ordre d'affichage"
  }
});
